<template>
  <div>
    <nuxt/>

    <snack-bar-errors></snack-bar-errors>
  </div>
</template>

<script>
import SnackBarErrors from "~/components/molecules/SnackBarErrors"

export default {
  components: {
    SnackBarErrors
  },
}
</script>
